module.exports = __webpack_public_path__ + "img/T.36cda1ad.svg";